@if (breadcrumbs && breadcrumbs.length) {
    <div class="ws-bread-crumbs">
        <ol class="breadcrumb float-start">
            @for (crumb of breadcrumbs; track crumb.name; let last = $last) {
                <li class="breadcrumb-item">
                    <a class="ace-btn btn-link pointer"
                       anchor-route
                       [sref]="crumb">{{ crumb.name }}</a>
                </li>
            }
            <li class="breadcrumb-item active"><span class="current-crumb">{{ currentPageTitle }}</span></li>
        </ol>
    </div>
}
